<template>
  <div class="row">
    <div class="col-md-8 row">
      <Select
        autoload 
        class="col-md-12"
        placeholder="Language"
        label="Choose a Language"
        v-model="model.lang"
        moduleName="languages"
        textField="text"
        valueField="value"
      />

      <TextField
        class="col-md-12"
        label="Title"
        placeholder="Enter Title for Template"
        v-model="model.title"
        :error="$v.model.title.$error"
        :errorMessage="$v.model.title.errorMessage"
      />

      <TextField
        class="col-md-12"
        label="Subject"
        placeholder="Enter Email Subject"
        v-model="model.subject"
        :error="$v.model.subject.$error"
        :errorMessage="$v.model.subject.errorMessage"
      />

      <Select
        autoload
        class="col-md-12"
        v-model="model.type"
        placeholder="Type"
        label="Type of Email"
        textField="text"
        valueField="value"
        moduleName="email_types"
        :error="$v.model.type.$error"
        :errorMessage="$v.model.type.errorMessage"
        @input="selectedVal"
        @selected="selectedVal"
        trackBy="value"
      />

    </div>
    <div class="col-md-4">
      <div class="alert alert-primary">
        <div class="small font-weight-bold">Please add the variables to email content</div>
        <div class="small">Variables:</div>
        <div class="small text-center" v-show="selectedType.length == 0">N/A</div>
        <div class="row">
          <div v-for="item in selectedType" :key="item" class="col-12">
            {{ item.clean ? item.value : "\{\{" + item + "\}\}" }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group col-md-12">
      <div class="textOnInput">
        <label class="form-label">Email Content:</label>
        <vue-editor height="300"
          placeholder="Enter Email Content"
          v-model="model.content"
        ></vue-editor>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@components/form2/textfield'
import Select from '@components/form2/select'
import { required } from 'vuelidate/lib/validators'
import Dropdown from '@src/static/dropdown'
import { VueEditor } from 'vue2-editor'


export default {
  components: {
    TextField,
    Select,
    VueEditor
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    templateID() {
      let parameters = this.parameters || {}
      return parameters.templateID
    }
  },
  data() {
    return {
      model: {
        title: '',
        subject: '',
        content: '',
        type: '',
      },
      selectedType:[],
    }
  },
  validations: {
    model:{
      title: { required },
      subject: { required },
      content: { required },
      type: { required }
    }
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.templateID

      return this.$store.dispatch('email_template/find', param)
      .then(res => {
        if (res?.data) {
          this.model = res.data;

          const typeOptions = Dropdown['email_types'];
          const langOptions = Dropdown['languages'];

          // Find matching type object
          const matchedType = typeOptions.find(option => option.value === this.model.type);
          if (matchedType) {
            this.model.type = { ...matchedType };
            this.selectedType = matchedType.variables;
          }

          // Find matching language object
          const matchedLang = langOptions.find(option => option.value === this.model.lang);
          if (matchedLang) {
            this.model.lang = matchedLang;
          }
        }
      })
    },
    selectedVal(val){
      if(typeof val == 'object'){
        this.selectedType = val.variables
      }
    }
  },
  mounted() {
    if (this.templateID) {
      this.fetchData()
    }
  },
  watch: {
    templateID: function () {
      this.fetchData()
    }
  }
}
</script>